module.exports = __webpack_public_path__ + "static/media/enisa.6e847b3f.md";